import React from 'react'
import { node } from 'prop-types'
// import styled from 'styled-components'
import { Box, Flex } from 'rebass'

export const GridWrapper = ({ children }) => (
  <Flex flexWrap={'wrap'} m={-1}>
    {children}
  </Flex>
)

GridWrapper.propTypes = {
  children: node
}

export const GridItem = ({ children }) => (
  <Box width={[1 / 1, 1 / 3]} p={1} flexGrow={1}>
    {children}
  </Box>
)

GridItem.propTypes = {
  children: node
}
